// extracted by mini-css-extract-plugin
export default {"modal":"SendMail_modal__KqDhO","modalContent":"SendMail_modalContent__iAYtc"};